export const VALUE_NOT_AVAILABLE = 'N/A';
export const ENTER_KEY_CODE = 13;
export const CBP_LANDING = 'car_buying_landing';
export const TOP_RATED = 'top_rated';
export const FACEBOOK_LANDING = 'brand_landing';
